import React from "react";
import { LegalPage } from "./LegalPage";
import { privacyPolicy } from "@/content/legal";

export default function Privacy() {
  return <LegalPage doc={privacyPolicy} testid="privacy-page" />;
}
